import Component from './Component';
import Utils from "../Utils";

export default class Shapes extends Component {

	/**
	 * @param {HTMLElement} element
	 * @param {Object} data
	 */
	constructor(element, data) {
		super(element, data);
		this.supportsSVG = document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
		if (this.supportsSVG) {
			Utils.loadSvgShapes(data.url, element);
		}
	}
};
